<template>
  <footer v-if="!isSymposium">
    <p>COPYRIGHT © {{baseCurrentYear}} ADMAN ALL RIGHTS RESERVED. | <router-link to="/privacy"> PRIVACY POLICY</router-link></p>
  </footer>
</template>

<script>
import { getBaseCurrentYear } from '@/environments'

export default {
  data () {
    return {
      baseCurrentYear: getBaseCurrentYear
    }
  },

  computed: {
    isSymposium () {
      // if (this.$route.name === 'symposium_video_login') {
      //   return true
      // }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

footer {
  z-index: 1;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -1px;
  width: 100%;
  padding: 22px 0;
  background-color: $light;

  p {
    margin: 0;
  }
}
</style>
